/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logout6Inputs */

const en_logout6 = /** @type {(inputs: Logout6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

const de_logout6 = /** @type {(inputs: Logout6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {Logout6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const logout6 = /** @type {((inputs?: Logout6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logout6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_logout6(inputs)
	return en_logout6(inputs)
});
export { logout6 as "LOGOUT" }